// React
import React, { Fragment } from "react";

// Custom UI Components
import H3Text from "@Uilib/h3Text";

// Helpers / Constants
import { toISTDate } from "@Apis/constants";

function ViewIncomingPaymentDetails({ selectedPaymentOutgoing, MONEY }) {
  return (
    <Fragment>
      <div className="document-header">
        <div className="ant-row">
          {(selectedPaymentOutgoing?.internal_cust_code || selectedPaymentOutgoing?.tenant_seller_info?.seller_name) && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text text={selectedPaymentOutgoing?.internal_cust_code ? "Customer" : "Vendor"} className="document-header__field-name" />
                <H3Text
                  text={`${selectedPaymentOutgoing?.internal_cust_code || selectedPaymentOutgoing?.tenant_seller_info?.internal_slr_code} - ${selectedPaymentOutgoing?.customer_name || selectedPaymentOutgoing?.tenant_seller_info?.seller_name}`}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}
          {selectedPaymentOutgoing?.tenant_info?.tenant_name && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text
                  text="Location"
                  className="document-header__field-name"
                />
                <H3Text
                  text={selectedPaymentOutgoing?.tenant_info?.tenant_name}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}
          {selectedPaymentOutgoing?.amount && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text
                  text="Payment Made"
                  className="document-header__field-name"
                />
                <H3Text
                  text={MONEY(selectedPaymentOutgoing?.amount || 0)}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}
          {selectedPaymentOutgoing?.utr_number && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text
                  text="Reference #"
                  className="document-header__field-name"
                />
                <H3Text
                  text={selectedPaymentOutgoing?.utr_number}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}
          {selectedPaymentOutgoing?.payment_date && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text
                  text="Payment Date"
                  className="document-header__field-name"
                />
                <H3Text
                  text={toISTDate(selectedPaymentOutgoing?.payment_date).format(
                    "DD/MM/YYYY hh:mm A"
                  )}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}
          {selectedPaymentOutgoing?.paid_through_account_id && (
            <div className="ant-col-md-12">
              <div className="document-header__field">
                <H3Text
                  text="Payment Account"
                  className="document-header__field-name"
                />
                <H3Text
                  text={selectedPaymentOutgoing?.paid_through_account_details?.account_name?.toProperCase()}
                  className="document-header__field-value"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
}

export default ViewIncomingPaymentDetails;
